// ** React Imports ** //
import React, { Fragment } from "react";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";
import "@/styles/pages/session.scss";

const Session = ({ isGuidePanel = false, heading = "No Sessions Booked Yet?" }) => {
  const navigate = useNavigate();

  console.log("Session Component Rendered");

  return (
    <div className="session-Wrapper">
      <div className="card-wrapper">
        <img src="/assets/images/availbility.png" />
        <div className="title-h4">{heading}</div>

        {!isGuidePanel && (
          <>
            <div className="body-b12 sublabel">
              Discover the perfect session for your study abroad journey. Book now!
            </div>
            <ButtonComponent
              label="Book Session Now"
              varient="primary"
              onClick={() => {
                console.log("Navigating to /guides");
                navigate("/guides");
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Session;
